import React from 'react';
import { Image } from 'components/Image';

import icon from 'images/icons/lyra.svg';

const Lyra = () => <Image src={icon} alt="stripe" />;

export default Lyra;